<template>
  <div
    class="full-width"
    style="height: 100%"
  >
    <div
      v-if="hasContact && !loading"
      class="row full-width justify-between"
      style="height: 98%"
    >
      <PanelPreviewData
        style="width: 60%; height: 100%"
        :show-return-button="false"
        :contact="contact"
      />
      <div
        class="right-panel"
        style="width: 39%;max-height: 100%;  "
      >
        <PanelPreviewPhones
          style="max-height:88%;"
          :phone-list="phones"
          :preview-contact="contact"
          @isDialing="handleIsDialing"
        />
        <PanelPreviewActions
          style="height: 10%;"
          @skip-contact="openSkipDialog"
          @finish-contact="finishCurrentContact"
          :preview-contact="contact"
          :is-dialing="isDialing"
        />
        <q-dialog
          v-model="openModal"
          true
        >
          <q-card class="modal-skip-contact">
            <q-card-section
              class="column items-center justify-between text-center full-height full-width"
            >
              <div class="text-bold modal-title q-mb-xs row justify-center">
                Confirmar ação
              </div>

              <div
                class="full-width q-py-sm q-px-md row items-start justify-start"
                style="background-color: #FFF3E0;"
              >
                <div class="column">
                  <div class="row justify-start items-center">
                    <q-icon
                      name="mdi-alert"
                      color="warning"
                    />
                    <div style="font-size: 14px; font-weight: bold; color: #E65000;margin-left: 10px;">
                      Contato não perfilado
                    </div>
                  </div>

                  <div
                    style="font-size: 12px; text-align: start; color: #EF6C00;"
                    class="text-bold"
                  >
                    Ao avançar você não poderá retornar para este contato
                  </div>
                </div>
              </div>

              <div class="full-width column items-start q-my-md">
                <FieldText
                  class="full-width"
                  v-model="skipReason"
                  label="Por favor, informe o motivo antes de avançar"
                  max-length="45"
                  height="40px"
                  :rules="[ val => val && val.length >=10 || 'A sua justificativa deve possuir no mínimo 10 caracteres']"
                />
              </div>

              <div class="row justify-between items-center full-width">
                <q-btn
                  color="primary"
                  icon="mdi-close"
                  label="Cancelar"
                  no-caps
                  outline
                  padding="10px 15px"
                  v-close-popup
                />
                <q-btn
                  color="primary"
                  icon="mdi-check"
                  label="Avançar"
                  no-caps
                  padding="10px 15px"
                  class="q-mr-xs"
                  :disabled="!skipReason || skipReason.length < 10"
                  @click="skipContact"
                />
              </div>
            </q-card-section>
          </q-card>
        </q-dialog>
      </div>
    </div>
    <PanelPreviewAlert
      v-else-if="loading"
      class="full-height"
      title="Carregando próximo contato !"
      subtitle-title="Buscando próximo contato disponível"
      subtitle-text="Aguarde um momento"
      :loading="true"
    />

    <PanelPreviewAlert
      v-else
      class="full-height"
      title="Nenhum contato disponível"
      subtitle-title="Não há contatos para discagem!"
      subtitle-text="Por favor insira novos contatos e atualize o painel"
      :update-button="true"
      @reload-contact="getNextContact"
    />
  </div>
</template>

<script>

import PanelPreviewActions from '@/components/PanelPreviewActions.vue'
import PanelPreviewAlert from '@/components/PanelPreviewAlert.vue'
import PanelPreviewData from '@/components/PanelPreviewData.vue'
import PanelPreviewPhones from '@/components/PanelPreviewPhones.vue'
import { getNationalFormatedNumber } from '@/libs/startAttendance'

import api from '@/libs/api'
import { mapActions, mapGetters, mapState } from 'vuex'
import FieldText from '@/components/FieldText.vue'

export default {
  components: {
    PanelPreviewData, PanelPreviewPhones, PanelPreviewAlert, PanelPreviewActions, FieldText
  },

  props: {
    attendanceId: {}
  },

  data () {
    return {
      profilerSelected: {},
      phones: [],
      contact: null,
      openModal: false,
      loading: false,
      skipReason: null,
      isDialing: false
    }
  },

  mounted () {
    if (this.previewContacts[this.queueId]) {
      this.contact = this.previewContacts[this.queueId]
      this.phones = this.contact.phones
    }
    if (!this.contact) {
      this.getNextContact()
    }
  },

  methods: {

    async getNextContact () {
      this.loading = true
      await this.manageContact()
      this.loading = false
    },

    ...mapActions({
      addContactToPreview: 'attendanceModule/addContactToPreview',
      removeContactFromPreview: 'attendanceModule/removeContactFromPreview'
    }),

    async manageContact () {
      const contact = await api.getNextPreviewContact(this.queueId, this.agentId)

      const normalizedPhones = {}
      for (const key in contact.phones) {
        const phoneObj = contact.phones[key]
        let areaCode = this.$store.state.settingsModule?.provision?.areaCode || ''
        if (!areaCode) areaCode = this.$store.state.agentModule?.provision?.areaCode || ''

        const number = this.formatPhone(phoneObj.number, areaCode)
        phoneObj.formatNumber = number
        normalizedPhones[number] = { ...phoneObj }
      }

      contact.phones = normalizedPhones
      this.contact = contact
      this.phones = normalizedPhones

      this.addContactToPreview({ contact, queueId: this.queueId })
    },

    async finishCurrentContact (status = 'FINISHED') {
      await api.postPreviewStatus(this.contact.id, status, this.skipReason)
      this.removeContactFromPreview(this.queueId)
      this.contact = null
      this.skipReason = null
      this.getNextContact()
    },

    openSkipDialog () {
      this.openModal = true
    },

    skipContact () {
      this.openModal = false
      this.finishCurrentContact('SKIPPED')
    },

    formatPhone (contactPhone, areaCode) {
      const phone = sanitize(contactPhone)
      const correctedNumber = correctNumber(phone)
      const result = getNationalFormatedNumber({ contact: correctedNumber }, areaCode)
      return result.contact
    },
    handleIsDialing (value) {
      this.isDialing = value
    }

  },

  computed: {
    ...mapGetters({
      isAdmin: 'settingsModule/isAdmin',
      agentId: 'agentModule/agent'
    }),

    ...mapState({
      previewContacts: ({ attendanceModule }) => attendanceModule.preview.contact
    }),

    queueId () {
      return this.$route.params.queueId
    },

    hasContact () {
      return Boolean(this.contact?.id)
    }

  },

  watch: {
    previewQueues: {
      handler (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.contact = this.previewContacts[this.queueId]
          this.phones = this.contact.phones
        }
      },
      deep: true
    }
  }
}

const sanitize = (phone) => (
  phone.split(/\D+/).join('')
)

const correctNumber = (number) => {
  if (number.startsWith('55') && number.length > 11) number = number.substr(2)

  const isMobile = ['8', '9'].includes(number[2])
  const ddd = number.slice(0, 2)
  if (number.length < 11 && isMobile) number = `${ddd}9${number.substr(2)}`

  return number
}

</script>

<style lang="sass" scoped>
.modal-title
  font-size: 16px
  font-weight: bold
  color: #444444
  width: 100%
  padding-bottom: 10px

.modal-skip-contact
  width: 400px
  padding:5px 5px

.right-panel
  display: flex
  flex-direction: column
  justify-content: space-between

</style>
